import React from "react";
import { Button } from "./ui/button";
import { MessageCircle, Phone, MapPin, Languages, Map } from "lucide-react";

const Contact = ({ language }) => {
  const whatsappLink =
    "https://wa.me/34722886101?text=Hola%20ProntoFix%20Valencia%2C%20necesito%20ayuda%20con...";
  const phoneLink = "tel:+34722886101";
  const googleReviewLink = "https://share.google/cN20emM34IkVzcLLq";

  const content = {
    es: {
      title: "Contacto",
      subtitle: "¿Necesitas ayuda? Contáctame ahora",
      phone: "+34 722 886 101",
      serviceArea: "Área de servicio",
      serviceAreaText: "Valencia y alrededores",
      languages: "Idiomas",
      languagesText: "Español (básico), English",
      whatsapp: "WhatsApp",
      call: "Llamar",
    },
    en: {
      title: "Contact",
      subtitle: "Need help? Contact me now",
      phone: "+34 722 886 101",
      serviceArea: "Service area",
      serviceAreaText: "Valencia and nearby areas",
      languages: "Languages",
      languagesText: "Spanish (basic), English",
      whatsapp: "WhatsApp",
      call: "Call",
    },
  };

  const currentContent = content[language];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-[#2563EB]" id="contact">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {/* Section Header */}
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {currentContent.title}
          </h2>
          <p className="text-lg sm:text-xl text-blue-100 mb-10">
            {currentContent.subtitle}
          </p>

          {/* Phone Display */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8">
            <p className="text-3xl sm:text-4xl font-bold text-white mb-6">
              {currentContent.phone}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  className="bg-white text-[#2563EB] hover:bg-gray-100 px-8 py-6 text-lg rounded-lg shadow-lg flex items-center gap-3 w-full sm:w-auto font-semibold"
                >
                  <MessageCircle className="w-5 h-5" />
                  {currentContent.whatsapp}
                </Button>
              </a>
              <a href={phoneLink}>
                <Button
                  size="lg"
                  variant="outline"
                  className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#2563EB] px-8 py-6 text-lg rounded-lg flex items-center gap-3 w-full sm:w-auto font-semibold"
                >
                  <Phone className="w-5 h-5" />
                  {currentContent.call}
                </Button>
              </a>
            </div>
          </div>

          {/* Additional Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-left">
            {/* Service Area */}
            <div className="flex items-start gap-3 bg-white/5 p-4 rounded-lg">
              <MapPin className="w-6 h-6 text-blue-200 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-semibold mb-1">
                  {currentContent.serviceArea}
                </h3>
                <p className="text-blue-100 text-sm">
                  {currentContent.serviceAreaText}
                </p>
              </div>
            </div>

            {/* Languages */}
            <div className="flex items-start gap-3 bg-white/5 p-4 rounded-lg">
              <Languages className="w-6 h-6 text-blue-200 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-white font-semibold mb-1">
                  {currentContent.languages}
                </h3>
                <p className="text-blue-100 text-sm">
                  {currentContent.languagesText}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-white/10 backdrop-blur-sm rounded-xl p-4 text-left">
            <a
              href={googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-3"
            >
              <Map className="w-5 h-5 text-blue-200 mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-white font-semibold">
                  {language === "es"
                    ? "Dejar reseña en Google ⭐⭐⭐⭐⭐"
                    : "Leave a Google review ⭐⭐⭐⭐⭐"}
                </div>
                <div className="text-blue-100 text-sm">
                  {language === "es"
                    ? "¿Te gustó el servicio? Déjame una reseña — me ayuda muchísimo."
                    : "Happy with the service? Leave a review — it really helps."}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
